export class DownloadNavigationData {
    public Name: string
    public Category: string
    public Link: string
}
